import React, { useState } from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import StickyNavigation from 'on_web/components/shared/Common/StickyNavigation/StickyNavigation';
import PageItemContainer from 'on_web/components/shared/Common/PageItemContainer/PageItemContainer';
import { makeStyles } from '@material-ui/core/styles';
import UserProfileContext from 'on_web/context/userProfileContext';
import useCheckScreenSize from 'on_web/hooks/useCheckScreenSize';

import { Trans, useTranslation } from 'react-i18next';

const useStyles = makeStyles({
  root: {
    whiteSpace: '-moz-pre-wrap' /* Mozilla */,
    whiteSpace: '-hp-pre-wrap' /* HP printers */,
    whiteSpace: '-o-pre-wrap' /* Opera 7 */,
    whiteSpace: '-pre-wrap' /* Opera 4-6 */,
    whiteSpace: 'pre-wrap' /* CSS 2.1 */,
    whiteSpace: 'pre-line' /* CSS 3 (and 2.1 as well, actually) */,
  },
});

function IntroTerms(props) {
  const context = React.useContext(UserProfileContext);
  const classes = useStyles();
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [isDesktop] = useCheckScreenSize();

  const onClickNext = () => {
    setTermsAccepted(!termsAccepted);
    const userMetadata = context ? context.user_metadata : null;
    if (props.onClickNext && userMetadata) {
      userMetadata.acceptedTerms = true;
      props.onClickNext(userMetadata);
    }
  };

  const onClickBack = () => {
    if (props.onClickBack) {
      props.onClickBack();
    }
  };

  const { t } = useTranslation();
  return (
    <div>
      <Box textAlign="left">
        <PageItemContainer>
          <Box textAlign="center" mt={2} mb={2} fontSize={24}>
            <Typography color="primary" variant="h2">
              {t('onboarding.introSection.introTerms.heading')}
            </Typography>
          </Box>
          <Box
            className={classes.root}
            mx={'10px'}
            mb={isDesktop ? '0' : '60px'}
          >
            <Typography variant="body1" paragraph>
              <Trans i18nKey="onboarding.introSection.introTerms.termsTextParagraph1" />
            </Typography>
            <Typography variant="body1" paragraph>
              <Trans i18nKey="onboarding.introSection.introTerms.termsTextParagraph2" />
            </Typography>
            <Typography variant="body1" paragraph>
              <Trans i18nKey="onboarding.introSection.introTerms.termsTextParagraph3">
                0
                <a
                  href="https://www.lifenome.com/privacy-policy/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  1
                </a>
                2
              </Trans>
            </Typography>
            <Typography variant="body1" paragraph>
              <Trans i18nKey="onboarding.introSection.introTerms.termsTextParagraph4">
                0
                <a
                  href="https://www.lifenome.com/privacy-policy/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  1
                </a>
                <a
                  href="mailto:research@lifenome.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  2
                </a>
                3
              </Trans>
            </Typography>
          </Box>
        </PageItemContainer>
      </Box>
      {props.noBottomNavigation ? (
        ''
      ) : (
        <StickyNavigation
          nextButtonText={t('onboarding.introSection.introTerms.agreement')}
          onClickNext={() => onClickNext()}
          onClickBack={() => onClickBack()}
        />
      )}
    </div>
  );
}

export default IntroTerms;
